module.exports = require('./helpers/bundle-url').getBundleURL('gjGB6') + "integrations.f862728a.svg";